import { Type2Link, Type2LinkType } from "./Type2Link";
import { Component, Input, OnInit, Optional } from "@angular/core";
import { PagingTableComponent, TabComponent, ModalTabComponent } from "@xo/client-common";
import { Type1BaseType } from "../type1base/Type1Base";
import { Type10MixedType } from "../type10mixed/Type10Mixed";

@Component({
    selector: "spec-app-type2-link-table",
    styleUrls: ["./type2Link.table.scss"],
    templateUrl: "./type2Link.table.html"
})
export class Type2LinkTable extends PagingTableComponent<Type2Link> implements OnInit {

    @Input() title: string;

    Type2Link = Type2Link;


    type1BasesForSimpleField = [];

    type1BasesForValidatedField = [];

    type1BasesForArrayField = [];

    type10MixedsForMixed = [];

    constructor(
        @Optional() modalTab: ModalTabComponent, @Optional() tab: TabComponent) {
        super(Type2LinkType, Type2Link.columnInfo, modalTab || tab);
    }

    async ngOnInit() {
        await this.loadTargetsForSimpleField();
        await this.loadTargetsForValidatedField();
        await this.loadTargetsForArrayField();
        await this.loadTargetsForMixed();
        this.refreshList();
    }

    async loadTargetsForSimpleField() {
        let type1BaseDataService = this.tab.getService(Type1BaseType);
        this.type1BasesForSimpleField = (await type1BaseDataService.list({}, "loadTargetsForSimpleField" + this.id)).page;
    }

    async loadTargetsForValidatedField() {
        let type1BaseDataService = this.tab.getService(Type1BaseType);
        this.type1BasesForValidatedField = (await type1BaseDataService.list({}, "loadTargetsForValidatedField" + this.id)).page;
    }

    async loadTargetsForArrayField() {
        let type1BaseDataService = this.tab.getService(Type1BaseType);
        this.type1BasesForArrayField = (await type1BaseDataService.list({}, "loadTargetsForArrayField" + this.id)).page;
    }

    async loadTargetsForMixed() {
        let type10MixedDataService = this.tab.getService(Type10MixedType);
        this.type10MixedsForMixed = (await type10MixedDataService.list({}, "loadTargetsForMixed" + this.id)).page;
    }

    getClasses(type2Link) {
        let classes: any = { objects: true };
        return classes;
    }
}
